module.exports = __webpack_public_path__ + "static/media/icot7-dark.ada4b1b9.svg";